import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import {
  Button, Form, Input, message
} from 'antd';
import { formItemLayout, tailLayout } from './ModalLayout';
import * as Service from '../core/Service';
import { useTranslation } from 'react-i18next';

const TncForm = (props) => {
  const {t} = useTranslation();

  const [form] = Form.useForm();
  const [formData, setFormData] = useState({});
  const {
    selectedRecord,
    openModal,
    involvedModelName,
  } = props;

  useEffect(() => {
    console.log('reset data')
    form.resetFields();
    console.log('setting data', selectedRecord)
    setFormData(selectedRecord);
  }, [form, selectedRecord]);

  useEffect(() => {
    form.setFieldsValue(formData);
  }, [form, formData]);

  const onFinish = async (formObj) => {
    let method = `POST`;
    let endpoint = `/api/${involvedModelName}/tnc`;

    console.log("tnc_id", formData.tnc_id);
    console.log("tnc", formObj)
    let bodyObj = _.clone(formObj);
    if (formData.tnc_id > 0) {
      bodyObj.tnc_id = formData.tnc_id;
      console.log("tnc after", bodyObj)
      method = `PUT`;
    }

    try {
      let resp = await Service.call(method, endpoint, bodyObj);
      if (resp.errorMessage) {
        message.error(resp.errorMessage);
        return;
      }
      message.success(t('common.success'));
      return openModal(false);
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <Form
      {...formItemLayout}
      form={form}
      onFinish={onFinish}
      initialValues={formData}
    >
      <Form.Item
        name="tnc_content"
        label={t('common.content')}
        rules={[{ required: true, message: `Please input` }]}
      >
        <Input.TextArea rows={20} />
      </Form.Item>
      <Form.Item {...tailLayout}>
        <Button
          type="primary"
          htmlType="submit"
        >
          {t("common.submit")}
        </Button>
      </Form.Item>
    </Form >
  );
}

export default TncForm;
